var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticStyle:{"width":"436px","height":"auto"},attrs:{"src":_vm.imagurl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }